import level4FatturazioneDettaglioFiscaleVariabili
    from './level4-02-fatturazione-02-dettagliofiscale-01-variabili.js'
    
const data = {
    "variabili": {
        label: "Variabili",
        description: "Alcune di queste voci potrebbero non essere presenti nella tua bolletta, variano da caso a caso.",
        labelKeywords: ["variabili"],
        contentKeywords: ["variabili"],
        img: "./images/02-fatturazione-02-dettagliofiscale-06-variabili.jpg",
        imgDescription: "Immagine che raffigura la prima pagina della bolletta, con evidenziata il campo dedicato alle altre variabili.",
        level4: level4FatturazioneDettaglioFiscaleVariabili
    }
}

export default data;